export default __webpack_public_path__ + "static/media/MahrooRahman.9964c98e.pdf";